import '../../static/css/home/ig.css';
import {ThinChevronRight} from "../../components/icons/material-icons";

export const HomeInstagramComponent = () => {
    return (
        <div className="home-instagram">
            <div className="row align-items-center justify-content-center">
                <div className="col-lg-1"/>
                <div className="col-lg-5">
                    <div className="home-instagram-logo" style={{backgroundImage:'url(/images/ig2.webp)'}}>
                        {/*<i style={{backgroundImage:'url(/svg/ig.svg)'}}/>*/}
                    </div>
                    <b>نهال را در اینستاگرام دنبال کنید.</b>
                    <p>برای مشاهده تصاویر و ویدیوهای نهال، می‌توانید همچنین در شبکه اجتماعی اینستاگرام نیز ما را دنبال نمایید.</p>
                    <a href="https://www.instagram.com/nahalgirlsschool/?hl=fa" target="_blank" rel="noreferrer">
                        <span>@nahalgirlsschool</span>
                        <i><ThinChevronRight/></i>
                    </a>
                    <div className="d-lg-none" style={{height:30}}/>
                </div>
                <div className="col-lg-6">
                    <img src="/images/ig.png" alt="اینستاگرام نهال"/>
                </div>
            </div>
        </div>
    );
};